import { makeLabels } from 'utils/i18n';

const NAMESPACE = 'page.merchant.accountSettings.refundAccounts.topupDetails';
export const LABELS = makeLabels(
  {
    TOPUP_ID: ['topupId', 'Top Up ID'],
    AMOUNT: ['amount', 'Amount'],
    STATUS: ['status', 'Status'],
  },
  NAMESPACE,
);
